import React from 'react';
import SectionTag from '../components/SectionTag';
import ScrollReveal from '../components/ScrollReveal';

const TEAM = [
  { name: 'Samantha Renz', role: 'CEO & Founder', initials: 'SR', color: '#3FC4E3', photo: '/team-samantha.jpg' },
  { name: 'Melanie Riden-Renz', role: 'Chief Operations Officer', initials: 'MR', color: '#006077', photo: '/team-melanie.jpg' },
  { name: 'Musharaf Ahmed', role: 'Tech Consultant', initials: 'MA', color: '#1DC37F', photo: '/team-musharaf.png' },
];

export default function Team() {
  return (
    <section id="team" style={{ background: '#ffffff', padding: '120px 5%' }}>
      <div className="max-w-screen-xl mx-auto">

        <div className="flex flex-col items-center text-center mb-16">
          <SectionTag label="OUR TEAM" />
          <h2 style={{ fontFamily: 'popinsBold', fontSize: 'clamp(28px, 4vw, 44px)', color: '#1B1A28', marginBottom: '12px' }}>
            The People Behind TCCplus
          </h2>
          <p style={{ fontFamily: 'popinsRegular', fontSize: '16px', color: '#6B7280', maxWidth: '520px' }}>
            A small, dedicated team united by one mission — making community support accessible to everyone.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
          {TEAM.map((member, i) => (
            <ScrollReveal key={member.name} direction="up" delay={i * 150}>
              <div
                className="flex flex-col items-center text-center transition-all duration-300"
                style={{
                  background: '#ffffff',
                  border: '1px solid #E5E5E5',
                  borderRadius: '20px',
                  padding: '40px 24px 32px',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = 'rgba(63,196,227,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)';
                  e.currentTarget.style.borderColor = '#E5E5E5';
                }}
              >
                {/* Avatar */}
                <div
                  style={{
                    width: '160px',
                    height: '160px',
                    borderRadius: '50%',
                    marginBottom: '20px',
                    boxShadow: `0 8px 32px ${member.color}44`,
                    overflow: 'hidden',
                    border: `4px solid ${member.color}`,
                    flexShrink: 0,
                    background: `linear-gradient(135deg, ${member.color}, ${member.color}99)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {member.photo ? (
                    <img
                      src={member.photo}
                      alt={member.name}
                      loading="lazy"
                      style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
                    />
                  ) : (
                    <span style={{ fontFamily: 'popinsBold', fontSize: '48px', color: '#ffffff' }}>
                      {member.initials}
                    </span>
                  )}
                </div>

                {/* Name */}
                <h3 style={{ fontFamily: 'popinsSemiBold', fontSize: '18px', color: '#1B1A28', marginBottom: '6px' }}>
                  {member.name}
                </h3>

                {/* Role */}
                <span style={{ fontFamily: 'popinsMedium', fontSize: '13px', color: member.color }}>
                  {member.role}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>

      </div>
    </section>
  );
}
